import {EditPermissions} from '../../../../../../../shared/models';
import {FormControl, FormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {required} from '../../../../../../../shared/utils';

export const NODE_TYPE = 'customTransform';

export interface CustomTransform {
    name: string;
    description: string;
    functionId: string;
    params: { [index: string]: string };
    success: string;
    error: string;
}

export class CustomTransformNode {

    action: any = {};

    constructor() {
        this.action = {
            actionType: NODE_TYPE,
        };
    }

    static toForm(step: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        const customTransform = this.getFormData(step);

        return this.buildForm(customTransform, editFlows);
    }

    private static getFormData(step: { [index: string]: any }): CustomTransform {

        const action = step?.action ? step?.action : {};
        const actionParams = action.actionParams ? action.actionParams : {};
        const results = action.result ? action.result : {};

        return {
            name: action.name ? action.name : '',
            description: action.description ? action.description : '',
            functionId: actionParams.functionId ? actionParams.functionId : '',
            params: actionParams.params ? actionParams.params : {},
            success: results.success ? results.success : newStepValue,
            error: results.error ? results.error : newStepValue
        };
    }

    private static buildForm(customTransform: CustomTransform, editFlows: boolean): FormGroup {
        return new FormGroup({

            name: new FormControl({
                value: customTransform.name,
                disabled: !editFlows
            }, required('Name')),

            description: new FormControl({
                value: customTransform.description,
                disabled: !editFlows
            }, required('Description')),

            functionId: new FormControl({
                value: customTransform.functionId,
                disabled: !editFlows
            }, required('FunctionId')),
            params: this.buildParamForm(customTransform.params, editFlows),
            success: new FormControl({
                value: customTransform.success,
                disabled: !editFlows
            }),
            error: new FormControl({
                value: customTransform.error,
                disabled: !editFlows
            }),
        });
    }

    public static buildParamForm(params: {}, editFlows: boolean): FormGroup {
        const paramsForm = new FormGroup({});
        for (const key in params) {
            paramsForm.addControl(key, new FormControl({
                value: params[key],
                disabled: !editFlows
            }, required('Value')), );
        }
        return paramsForm;
    }

    public addNodeDetails(customTransform: CustomTransform) {

        const {name, description, functionId, error, params, success} = customTransform;

        const actionParams = {
            functionId,
        };

        if (params) {
            actionParams['params'] = params;
        }

        const result = {
            success,
            error
        };

        this.action = {
            ...this.action,
            name,
            description,
            actionParams,
            result
        };

    }

    public get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

}


// step1:
//     action:
//         name: "WA Demo"
//         description: "WA Demo"
//         actionType: "customTransform" // TBD not sure what to call it
//         actionParams:
//             functionId: "8313fc05db1b441b92ee2237602c5218"
//             params:
//                 bloo: "haha"
//                 name: "bloo"
//         result:
//             success: "step9"
//             error: "step3"
//     type: "action"
//     metadata:
//         stepUniqueID: "29fc9d0e-b0c4-47e1-96d0-b7ad4bad4bbf"
//         nodeVersion: "1.0.0"
